import { render, staticRenderFns } from "./NotePage.vue?vue&type=template&id=1bf65975&scoped=true"
import script from "./NotePage.vue?vue&type=script&lang=js"
export * from "./NotePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf65975",
  null
  
)

export default component.exports